<script setup>
import { defineProps } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

/**
 * I dati di un prodotto del catalogo ZDHC, come si mostrano.
 *
 * Solo il contenuto: non e' un pulsante, non e' una riga di elenco, non decide
 * niente. Chi lo usa lo mette dove serve — dentro una scheda cliccabile
 * dell'elenco dei candidati, o dentro un riquadro che ricorda a quale prodotto
 * si e' gia' associati. Sono la stessa cosa mostrata, e tenerne due copie
 * significherebbe che alla prossima aggiunta se ne aggiorna una sola.
 */

const props = defineProps({
    product: { required: true },
});

const { t } = useI18n();
const store = useStore();
</script>
<template>
    <span class="flex flex-col space-y-1">
        <slot name="heading">
            <span class="font-semibold capitalize">{{ props.product.product_name ?? '-' }}</span>
        </slot>
        <span class="text-sm">
            {{ t('productTable.cols.formulator', store.state.locale) }}:
            {{ props.product.formulator_name ?? '-' }}
        </span>
        <span class="text-sm">
            {{ t('productTable.cols.reference_id', store.state.locale) }}: {{ props.product.product_reference_id ?? '-' }}
        </span>
        <span v-if="props.product.conformance_level_name || props.product.ctz_level_name" class="text-sm">
            <template v-if="props.product.conformance_level_name">ZDHC MRSL: {{ props.product.conformance_level_name }}</template>
            <template v-if="props.product.conformance_level_name && props.product.ctz_level_name"> · </template>
            <template v-if="props.product.ctz_level_name">CtZ: {{ props.product.ctz_level_name }}</template>
        </span>
    </span>
</template>
